const dateTime = new Intl.DateTimeFormat(undefined, { dateStyle: 'medium', timeStyle: 'short' });
const dateOnly = new Intl.DateTimeFormat(undefined, { dateStyle: 'medium' });
const rtf = new Intl.RelativeTimeFormat(undefined, { numeric: 'auto' });
const numberFmt = new Intl.NumberFormat();

export const formatDateTime = (iso: string | null | undefined) =>
  iso ? dateTime.format(new Date(iso)) : '—';
export const formatDate = (iso: string | null | undefined) =>
  iso ? dateOnly.format(new Date(iso)) : '—';
export const formatNumber = (n: number | null | undefined) =>
  n === null || n === undefined ? '—' : numberFmt.format(n);

export function timeAgo(iso: string | null | undefined): string {
  if (!iso) return 'never';
  const seconds = (new Date(iso).getTime() - Date.now()) / 1000;
  const abs = Math.abs(seconds);
  if (abs < 60) return 'just now';
  if (abs < 3600) return rtf.format(Math.round(seconds / 60), 'minute');
  if (abs < 86400) return rtf.format(Math.round(seconds / 3600), 'hour');
  if (abs < 86400 * 30) return rtf.format(Math.round(seconds / 86400), 'day');
  return formatDate(iso);
}

const ACRONYMS: Record<string, string> = {
  qc: 'QC',
  lpn: 'LPN',
  sku: 'SKU',
  gln: 'GLN',
  ship_to: 'Ship-to',
};

export const titleCase = (s: string) =>
  ACRONYMS[s.toLowerCase()] ?? s.replace(/[_.]/g, ' ').replace(/\b\w/g, (c) => c.toUpperCase());

export const pct = (part: number, whole: number) => (whole ? Math.round((part / whole) * 100) : 0);
